import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jm2d4g869f: FaireBrandEntity = {
  token: "b_jm2d4g869f",
  type: "brand",
  name: "St. Meto",
  avatarUrl:
    "https://cdn.faire.com/fastly/6ce1fc4ad33486243df2e321a205d569933d73425f106d875b61ca6b096b57db.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/eb5dd373acb207763e1a61d32a9ef2fb04b4498da0d8da1ee5c3ceaad282953f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6ce1fc4ad33486243df2e321a205d569933d73425f106d875b61ca6b096b57db.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eb5dd373acb207763e1a61d32a9ef2fb04b4498da0d8da1ee5c3ceaad282953f.jpeg",
  location: "Los Angeles , CA, USA",
  minimumOrderDollars: 0,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Voted Best Hair Treatment by Esquire. Now sold on Goop & can be seen loved by editors in W Mag, Modern Luxury, Esquire & Town and Country.\n\nSt. Meto is a heritage lifestyle brand making luxury products for hair, body and home, inspired by nature and formulated by celebrity hairstylist & groomer Kristen Shaw.\nWe are inspired by a slower, simpler time when our connection to nature and the cycle of seasons and harvest were a part of everyday. We believe all good things take time and that small steps eventually write our story. \n\nGuided by the ancient teachings of our planet and its resources, we create each of our products with an alchemist’s approach; finding the harmony in every formulation that leaves our doors.\n\nOur offerings come from a personal desire to ignite the joy in caring for yourself, each product overflowing with elements to nourish and reinvigorate the senses. Nature gives us all the gifts our bodies need and we are simply here to be the shepherd.\n\nOur hero launch product, Mother Clay, is a healing hair and scamp treatment that harnesses the powerful energy of calcium bentonite clay, sourced from the American West and blended with nature's most potent ingredients. Crafted to detox, hydrate, and restore balance, this treatment envelops your hair in a gentle, renewing embrace, leaving it soft, resilient, and naturally radiant.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:27.692Z",
    importedBy: "entity-db-cli",
  },
};
